import React from 'react';

import ships from '../../const/ships.1.json';
import DexCard from '../../components/DexCard';

const hullTypes = {
  'Light Aircraft Carrier': 'CVL',
  'Destroyer': 'DD',
  'Light Cruiser': 'CL',
  'Heavy Cruiser': 'CA',
  'Battlecruiser': 'BC',
  'Battleship': 'BB',
  'Aircraft Carrier': 'CV',
  'Monitor': 'BM',
  'Battle Monitor': 'BM',
  'Repair Ship': 'AR',
  'Submarine': 'SS',
  'Battleship →  Aviation Battleship': 'BB → BBV',
  'Light Cruiser →  Heavy Cruiser': 'CL → CA',
};

export default function Azurdex() {
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
      {ships.map(ship => (
        <DexCard
          key={ship.id}
          iconUrl={`https://azurlane.koumakan.jp/${ship.icon}`}
          name={ship.name}
          rarity={ship.rarity.toLowerCase().replace(/\s/g, '_')}
          number={ship.id}
          hullType={hullTypes[ship.hull_type] || ship.hull_type}
        />
      ))}
    </div>
  );
}
